import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"

const alertVariants = cva(
  "dsw-relative dsw-w-full dsw-rounded-lg dsw-border dsw-px-4 dsw-py-3 dsw-text-sm [&>svg+div]:dsw-translate-y-[-3px] [&>svg]:dsw-absolute [&>svg]:dsw-left-4 [&>svg]:dsw-top-4 [&>svg]:dsw-text-foreground [&>svg~*]:dsw-pl-7",
  {
    variants: {
      variant: {
        default: "dsw-bg-background dsw-text-foreground",
        destructive:
          "dsw-border-destructive/50 dsw-text-destructive dsw-dark:border-destructive [&>svg]:dsw-text-destructive",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
))
Alert.displayName = "Alert"

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn("dsw-mb-1 dsw-font-medium dsw-leading-none dsw-tracking-tight", className)}
    {...props}
  />
))
AlertTitle.displayName = "AlertTitle"

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("dsw-text-sm [&_p]:dsw-leading-relaxed", className)}
    {...props}
  />
))
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertTitle, AlertDescription } 